<template>
  <v-dialog width="620" v-model="dialog" persistent scrollable>
    <v-card>
      <v-card-title class="blue darken-4 white--text">
        <v-toolbar-title>CẬP NHẬP THÔNG TIN CHĂM SÓC</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn dark icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text class="pa-6">
        <v-form v-bind="this.$attrs">
          <v-select
            :items="segmentOptions"
            label="Phân khúc"
            hide-details
            item-text="label"
            item-value="value"
            v-model="segment"
            outlined
            class="pb-6"
          ></v-select>
          <div v-for="(product, index) in localProfile.products" :key="product.id">
            <div class="d-flex justify-space-between pb-6">
              <v-select
                :items="getAvailableProducts(index)"
                item-text="name"
                item-value="id"
                v-model="localProfile.products[index]"
                :label="`Chọn hệ đào tạo đăng ký ${index + 1}`"
                return-object
                outlined
                hide-details
              ></v-select>
              <v-icon class="ml-6" @click="removeProduct(index)">mdi-trash-can</v-icon>
            </div>
          </div>
          <div class="d-flex justify-space-between">
            <v-spacer></v-spacer>
            <v-btn outlined color="blue darken-4" @click="addProduct">Thêm</v-btn>
          </div>

          <v-select
            label="Mức độ quan tâm"
            :items="interestOptions"
            item-text="label"
            item-value="value"
            v-model="interest"
            outlined
            hide-details
            class="pt-6"
          ></v-select>
          <v-textarea class="pt-6" label="Ghi chú" v-model="note" outlined hide-details></v-textarea>
          <v-text-field label="Nguồn" v-model="origin" outlined hide-details class="py-6"></v-text-field>
          <div v-for="(inCharge, index) in localProfile.inCharge" :key="inCharge.id">
            <div class="d-flex justify-space-between pb-6">
              <v-select
                :items="getAvailableInCharges(index)"
                :item-text="getItemText"
                item-value="id"
                v-model="localProfile.inCharge[index]"
                :label="`Chọn người phụ trách ${index + 1}`"
                return-object
                outlined
                hide-details
              ></v-select>
              <v-icon class="ml-6" @click="removeInCharge(index)">mdi-trash-can</v-icon>
            </div>
          </div>
          <div class="d-flex justify-space-between">
            <v-spacer></v-spacer>
            <v-btn outlined color="blue darken-4" @click="addInCharge">Thêm</v-btn>
          </div>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="d-flex justify-space-between pa-6">
        <v-btn color="blue darken-4" outlined @click="close">Hủy </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-4" dark @click="submit">Xác nhận</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  props: {
    state: Boolean,
    products: Array,
    profile: Object,
    inChargeList: Array,
  },
  data() {
    return {
      dialog: false,
      loading: false,
      selectedProduct: null,
      selectedInCharge: null,
      localProfile: null,
      interest: '',
      segment: '',
      origin: '',
      note: '',
      interestOptions: [
        { label: 'Thấp', value: 'cold' },
        { label: 'Vừa', value: 'warm' },
        { label: 'Cao', value: 'hot' },
      ],
      segmentOptions: [
        { label: 'Phổ thông', value: 'intermediate' },
        { label: 'Cao cấp', value: 'advance' },
      ],
    }
  },
  watch: {
    state(state) {
      this.dialog = state
      if (!state) this.loading = false
    },
    profile: {
      immediate: true,
      handler(newProfile) {
        if (newProfile) {
          this.localProfile = JSON.parse(JSON.stringify(newProfile))
          this.setFormValues(this.localProfile)
        }
      },
    },
    'profile.products': {
      handler(newVal) {
        if (newVal && newVal.length > 0) {
          this.localProfile.products = newVal.map((item) => ({ ...item }))
        } else {
          this.localProfile.products = [{}]
        }
      },
      deep: true,
    },

    'profile.inCharge': {
      handler(newVal) {
        if (newVal && newVal.length > 0) {
          this.localProfile.inCharge = newVal.map((item) => ({ ...item }))
        } else {
          this.localProfile.inCharge = [{}]
        }
      },
    },
  },
  computed: {
    ...mapGetters('auth', ['user']),
  },

  methods: {
    ...mapActions('lead', ['updateLead']),
    close() {
      this.$emit('closeDialog')
    },
    addProduct() {
      this.localProfile.products.push('')
    },
    removeProduct(index) {
      if (this.localProfile.products.length > 1) {
        this.localProfile.products.splice(index, 1)
      } else {
        this.$set(this.localProfile.products, index, {})
      }
    },
    addInCharge() {
      this.localProfile.inCharge.push('')
    },
    removeInCharge(index) {
      if (this.localProfile.inCharge.length > 1) {
        this.localProfile.inCharge.splice(index, 1)
      } else {
        this.$set(this.localProfile.inCharge, index, {})
      }
    },
    async submit() {
      this.$loading.active = true

      const isProductEmpty = (product) => {
        return !product || Object.keys(product).length === 0 || !product.id
      }
      const isInChargeEmpty = (inCharge) => {
        return !inCharge || Object.keys(inCharge).length === 0 || !inCharge.id
      }

      const filteredProducts = this.localProfile.products.filter((product) => !isProductEmpty(product))
      const filteredInCharge = this.localProfile.inCharge.filter((inCharge) => !isInChargeEmpty(inCharge))
      let lead = {
        interest: this.interest,
        segment: this.segment,
        products: filteredProducts,
        importOrigin: this.origin,
        inCharge: filteredInCharge,
        note: this.note,
      }
      const updateLead = await this.updateLead({ id: this.profile.id, ...lead })

      if (updateLead) {
        this.$emit('refresh')
        this.close()
      } else {
        this.$alert.error('Lỗi cập nhập khách hàng')
      }
    },
    setFormValues(profile) {
      this.interest = profile.interest || ''
      this.segment = profile.segment || ''
      this.origin = profile.importOrigin || ''
      this.note = profile.note || ''

      if (profile.products && profile.products.length > 0) {
        this.localProfile.products = profile.products
      } else {
        this.localProfile.products = [{}]
      }
      if (profile.inCharge && profile.inCharge.length > 0) {
        this.localProfile.inCharge = profile.inCharge
      } else {
        this.localProfile.inCharge = [{}]
      }
    },
    getItemText(item) {
      return item.name || item.username
    },
    getAvailableProducts(index) {
      const currentProductId = this.localProfile.products[index].id
      return this.products.filter(
        (product) =>
          product.id === currentProductId ||
          !this.localProfile.products.some((selectedProduct) => selectedProduct.id === product.id)
      )
    },
    getAvailableInCharges(index) {
      const currentInCharge = this.localProfile.inCharge[index].id
      return this.inChargeList.filter(
        (inCharge) =>
          inCharge.id === currentInCharge ||
          !this.localProfile.inCharge.some((selectedInCharge) => selectedInCharge.id === inCharge.id)
      )
    },
  },
}
</script>
